import React, { Component } from "react";
import { Row, Col, Container } from 'react-bootstrap'
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import PreloaderTwo from '../components/preloader/PreloaderTwo';
import Preloader from "../components/preloader/Preloader";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";
import Enquiry_Links from "../components/EnquiryLinksCreation/enquiryLinks";

const GET_ADMISSION_FIELD_TYPES = gql`
  query($id: Int!) {
    getFormFields(id: $id) {
        id
        form_field_name
    }
  }
`;


const FETCH_GLOBALS = gql`
query($institution_id: Int!) {
  globals(institution_id: $institution_id) {
    globalBranches {
      id
      branch_name
    }
  }
}
`

class EnquiryLink extends Component {

  menuToggler = () => {

    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };
  render() {
    if (Cookies.get("token") == undefined) this.props.history.push("/login");
    const getFormFields = this.props.getFormFields;
    console.log("getFormFields", getFormFields);
    const loading1 = getFormFields.loading;
    const error1 = getFormFields.error;

    if (error1 !== undefined) {
      alert("Server Error. " + error1.message);
      return null;
    }


    const globals = this.props.globals;
    const loading3 = globals.loading;
    const error3 = globals.error;

    if (error3 !== undefined) {
      alert("Server Error. " + error1.message);
      return null;
    }
    console.log("this", this.state);
    return (

      <div className={Cookies.get("toggle")}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">

          <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0" style={{ minHeight: "50vh" }}>

            <Container fluid>
              {
                loading1 || loading3 ?
                  (
                    <Container>
                      <Row className="my-2">
                        <Col>
                          <div className="spinner-border text-primary text-center loading-img-center"></div>
                        </Col>
                      </Row>
                    </Container>
                  ) :
                  (
                    <>
                      {
                        (() => {
                          let globalsData = globals.globals;
                          if (Cookies.get("userlevel") != "1" && Cookies.get("userlevel") != "2") {
                            let globalBranches = [];
                            globalsData.globalBranches.map((item) => {
                              if (Cookies.get("branch_id") == item.id) {
                                globalBranches.push(item)
                              }
                            });
                            globalsData.globalBranches = globalBranches
                          }
                          return (
                            <>
                              <Enquiry_Links
                                globals={globalsData}
                                getFormFields={getFormFields.getFormFields}
                              />
                            </>
                          )
                        })()
                      }
                    </>
                  )
              }
            </Container>
          </div>
          <Footer />
        </div>
      </div>

    );
  }
}

export default withRouter(compose(
  graphql(GET_ADMISSION_FIELD_TYPES, {
    options: (props) => ({
      variables: {
        id: 0,
      },
    }),
    name: "getFormFields",
  }),

  graphql(FETCH_GLOBALS, {
    options: (props) => ({
      variables: {
        institution_id: parseInt(Cookies.get("institutionid")),
      },
    }),
    name: "globals",
  }),
)(EnquiryLink));

